module.exports = __webpack_public_path__ + "img/logo-12.44a21e49.png";